module.exports = __webpack_public_path__ + "img/Dodger1.5b76f867.png";